import { createRoot, Root } from 'react-dom/client'

class ModalAction<T = unknown> {
  root_id = ''

  list: T[] = []

  root: Root | null = null

  constructor(id: string) {
    this.root_id = id
    this.set_root()
  }

  set_root = () => {
    if (!document) return

    let $wrapper = document.getElementById(this.root_id)
    if (!$wrapper) {
      $wrapper = document.createElement('div')
      $wrapper.id = this.root_id
      document.body.appendChild($wrapper)
    }

    /* eslint-disable */
    this.root = createRoot($wrapper)
  }
}

export default ModalAction
